import * as React from 'react'
import * as ClientSidePagination from '../Data/ClientSidePagination'
import NavigationChevronLeft from 'material-ui/svg-icons/navigation/chevron-left'
import NavigationChevronRight from 'material-ui/svg-icons/navigation/chevron-right'
import IconButton from 'material-ui-next/IconButton'

export function ClientSidePaginationView<T>({itemsPerPage, pagination, onPrevious, onNext}: {
    itemsPerPage: number,
    pagination: ClientSidePagination.ClientSidePagination<T>,
    onPrevious: () => void,
    onNext: () => void,
}) {
    return (
        <div>
            <IconButton
                disabled={pagination.currentPage === 1}
                onClick={onPrevious}
            >
                <NavigationChevronLeft/>
            </IconButton>
            <span>
                {pagination.currentPage} /&#x20;
                {ClientSidePagination.numberOfPages(itemsPerPage, pagination)}
            </span>
            <IconButton
                disabled={
                    pagination.currentPage ===
                    ClientSidePagination.numberOfPages(itemsPerPage, pagination)
                }
                onClick={onNext}
            >
                <NavigationChevronRight/>
            </IconButton>
        </div>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/ClientSidePaginationView.tsx